module.exports = __webpack_public_path__ + "static/media/red04.41dc2b3b.svg";